"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.setFilterOptions = exports.setOrderByOptions = exports.fetchLinkedFailure = exports.fetchLinkedSuccess = exports.fetchLinkedRequest = void 0;
const ActionTypes = require("../../actionTypes/vektorio/linkedFolders");
const fetchLinkedRequest = (payload) => ({
    type: ActionTypes.FETCH_LINKED_REQUEST,
    payload
});
exports.fetchLinkedRequest = fetchLinkedRequest;
const fetchLinkedSuccess = (payload) => ({
    type: ActionTypes.FETCH_LINKED_SUCCESS,
    payload
});
exports.fetchLinkedSuccess = fetchLinkedSuccess;
const fetchLinkedFailure = (payload) => ({
    type: ActionTypes.FETCH_LINKED_FAILURE,
    payload
});
exports.fetchLinkedFailure = fetchLinkedFailure;
const setOrderByOptions = (orderBy, order) => ({
    type: ActionTypes.SET_ORDER_BY_OPTIONS,
    payload: {
        orderBy,
        order
    }
});
exports.setOrderByOptions = setOrderByOptions;
const setFilterOptions = (filter, value) => ({
    type: ActionTypes.SET_FILTER_OPTIONS,
    payload: {
        filter,
        value
    }
});
exports.setFilterOptions = setFilterOptions;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=linkedFolders.js.map